export default [{
  path: '',
  component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/Main.vue'),
  children: [
    {
      path: 'relatorio/:tipo',
      name: 'configuracao.relatorio.tipo',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/ViewList.vue'),
    },
    {
      path: 'relatorio/veiculos',
      name: 'configuracao.relatorio.veiculos',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/Veiculo.vue'),
    },
    {
      path: 'relatorio/veiculo_secretaria',
      name: 'configuracao.relatorio.veiculo_secretaria',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/VeiculoSecretaria.vue'),
    },
    {
      path: 'relatorio/veiculo_ausencia_dados',
      name: 'configuracao.relatorio.veiculo_ausencia_dados',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/VeiculoAusenciaDados.vue'),
    },
    {
      path: 'relatorio/motorista_sem_foto',
      name: 'configuracao.relatorio.motorista_sem_foto',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/MotoristaSemFoto.vue'),
    },
    {
      path: 'relatorio/veiculo_frequencia',
      name: 'configuracao.relatorio.veiculo_frequencia',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/VeiculoFrequencia.vue'),
    },
    {
      path: 'relatorio/contrato',
      name: 'configuracao.relatorio.contrato',
      component: () => import(/* webpackChunkName: 'relatorio' */'@/views/private/configuracao/relatorio/Contrato.vue'),
    },
  ],
}];
